import React from "react";
import PropTypes from "prop-types";
import Alerts from "./Alerts";
import Filters from "./Filters/index";

const Toolbar = ({ serviceTypes, jobAlert, artistLoggedIn }) => {
  return (
    <div className="b-toolbar">
      <Filters />
      <Alerts
        serviceTypes={serviceTypes}
        jobAlert={jobAlert}
        isArtistLoggedIn={artistLoggedIn}
      />
    </div>
  );
};

Toolbar.propTypes = {
  serviceTypes: PropTypes.object.isRequired,
  jobAlert: PropTypes.object,
  artistLoggedIn: PropTypes.bool.isRequired,
};

Toolbar.defaultProps = {
  jobAlert: null,
};

export default Toolbar;
